import React, { useState } from "react";

const CalcsContext = React.createContext()

function CalcsProvider( { children } ) {
    const [calcMap, setCalcMap] = useState({});
    const [itemMap, setItemMap] = useState({});

    return (
        <CalcsContext.Provider value={ { calcMap, setCalcMap, itemMap, setItemMap } }>
            { children }
        </CalcsContext.Provider>
    )
}

export { CalcsContext, CalcsProvider }